import { h } from "preact";
import { useEffect, useMemo, useState } from "preact/hooks";

import type { ISourceOptions } from "@tsparticles/engine";
import { initParticlesEngine, Particles } from "@tsparticles/react";
import { loadFull } from "tsparticles";

const ParticlesContainer = () => {
    const [init, setInit] = useState(false);

    // this should be run only once per application lifetime
    useEffect(() => {
        initParticlesEngine(async engine => {
            await loadFull(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    const options: ISourceOptions = useMemo(
        () => ({
            fullScreen: {
                zIndex: 1
            },
            particles: {
                number: {
                    value: 0
                },
                color: {
                    value: [
                        "#F69833",
                        "#FECF33",
                        "#419BF9"
                    ]
                },
                shape: {
                    type: [
                        "square",
                        "circle"
                    ],
                    options: {}
                },
                size: {
                    value: {
                        min: 4,
                        max: 8
                    }
                },
                links: {
                    enable: false
                },
                life: {
                    duration: {
                        sync: true,
                        value: 10
                    },
                    count: 1
                },
                move: {
                    enable: true,
                    gravity: {
                        enable: true
                    },
                    drift: {
                        min: -2,
                        max: 2
                    },
                    speed: {
                        min: 10,
                        max: 30
                    },
                    decay: 0.1,
                    direction: "none",
                    straight: false,
                    outModes: {
                        default: "destroy",
                        top: "none"
                    }
                },
                rotate: {
                    value: {
                        min: 0,
                        max: 360
                    },
                    direction: "random",
                    move: true,
                    animation: {
                        enable: true,
                        speed: 60
                    }
                },
                roll: {
                    enable: true,
                    speed: {
                        min: 15,
                        max: 25
                    }
                },
                wobble: {
                    distance: 30,
                    enable: true,
                    move: true,
                    speed: {
                        min: -15,
                        max: 15
                    }
                }
            },
            emitters: {
                life: {
                    count: 0,
                    duration: 0.1,
                    delay: 0.4
                },
                rate: {
                    delay: 0.15,
                    quantity: 25
                },
                size: {
                    width: 10,
                    height: 10
                }
            }
        }),
        []
    );

    if (init) {
        return (
            <Particles
                id="tsparticles"
                options={options}/>
        );
    }

    return null;
};

export default ParticlesContainer;
